import React from 'react';
import { use } from 'react';
import { useState } from 'react';
import SelectorCiudad  from '../../../components/callejero/selectorCiudad';
import ConfiguradorCallejero from '../../../components/callejero/configuradorCallejero';
import cabecera from '../../../assets/images/entrenamientos.jpg'
import { Container, Row, Col } from 'react-bootstrap'
import MapaMudo from '../../../components/callejero/mapaMudo';


const Callejero = () => {

    const [ciudad, setCiudad] = useState(null);
    const [callejero, setCallejero] = useState(null);

    

     return (
      
        <div className="iq-breadcrumb-one  iq-bg-over iq-over-dark-50" style={{backgroundImage: `url(${cabecera})`}}>  
            <Container fluid> 
                <Row className="align-items-center">
                    <Col sm="12">
                        <div>

      {
        callejero === null ? (
          ciudad === null ? (
            <SelectorCiudad onSeleccionarCiudad={setCiudad} />
          ) : (
            <ConfiguradorCallejero ciudad={ciudad} onCallejero={setCallejero} />
          )
        ) : (
          <MapaMudo callejero={callejero} ciudad={ciudad} />
        )
      }
    </div>
                    </Col>
                </Row> 
            </Container>
        </div>


    
  );
};

export default Callejero;
